import { flatCheckboxGroupsToItems } from '../../../helpers/flatCheckboxGroupsToItems';
import { CheckboxGroupsChangeModelLazy } from '../../../models/CheckboxGroupsChangeModel';
export function prepareCheckboxGroupsChangeModel(groups, checkboxGroupItemChangeModel) {
  var calcAllItems = function calcAllItems() {
    var allValuesCollections = new Set(checkboxGroupItemChangeModel.allValues);
    return flatCheckboxGroupsToItems(groups).filter(function (item) {
      return allValuesCollections.has(item.value);
    });
  };

  return new CheckboxGroupsChangeModelLazy(checkboxGroupItemChangeModel, calcAllItems);
}